import { cssVar } from '../../theme/variables.js';
import { styled } from 'styled-components';
import { Flex } from '../Flex.js';
import { mediaHover } from '../../constants/styled-utils.js';

const ListItem = styled.div.withConfig({
  displayName: "List__ListItem",
  componentId: "sc-541b687-0"
})([
  `border:1px solid `,
  `;border-radius:`,
  `;background:`,
  `;padding:1rem;z-index:1;transition:z-index 0.1s step-end,border-color 0.2s linear;width:100%;position:relative;& + &{margin-top:-1px;}&:not([data-hover-state='false']){`,
  `{&:hover{transition:z-index 0.1s step-start,border-color 0.2s linear;z-index:5;border-color:`,
  `;}}}`
], cssVar["color-border-primary"], cssVar["radius-input"], cssVar["color-bg-primary"], mediaHover, cssVar["color-app-primary"]);
const ListContainer = styled(Flex).attrs({
  direction: "column"
}).withConfig({
  displayName: "List__ListContainer",
  componentId: "sc-541b687-1"
})([
  ``
]);
const ListItemTitle = styled.div.withConfig({
  displayName: "List__ListItemTitle",
  componentId: "sc-541b687-2"
})([
  `color:`,
  `;font-size:1rem;line-height:1.25rem;`
], cssVar["color-text-secondary"]);
const ListItemDescription = styled.div.withConfig({
  displayName: "List__ListItemDescription",
  componentId: "sc-541b687-3"
})([
  `color:`,
  `;font-size:0.875rem;`
], cssVar["color-text-tertiary"]);

export { ListContainer, ListItem, ListItemDescription, ListItemTitle };
//# sourceMappingURL=List.js.map
